import { SchemaCRUD } from '@/components/crud/SchemaCRUD';

const Tokens = () => {
	return (
		<SchemaCRUD
			entity="tokens"
			title="Tokens"
			description="Gerenciar tokens e contratos inteligentes"
			apiEndpoint="v1/tokens"
		/>
	);
};

export default Tokens;
